import type { ReactNode } from 'react';

import { getTestId } from 'utils/testing';

interface ConditionalLinkProps {
  href?: string;
  onClick?: () => void;
  className?: string;
  ariaLabel?: string;
  testId?: string;
  children: ReactNode;
}

/**
 * Conditional wrapper that renders either a link or span based on href presence.
 * onClick and other link-specific props will only
 * be interactive when rendering as an anchor tag.
 */
const ConditionalLink = ({ href, children, onClick, className, ariaLabel, testId }: ConditionalLinkProps) =>
  href ? (
    <a href={href} className={className} onClick={onClick} aria-label={ariaLabel} data-test-id={getTestId(testId)}>
      {children}
    </a>
  ) : (
    <span className={className} data-test-id={getTestId(testId)}>
      {children}
    </span>
  );

export default ConditionalLink;
